'use strict';

$('.toggle-sidebar').on('click', function (e) {
  e.preventDefault();
  $('.blog-sidebar').toggleClass('shown');
  $('.toggle-sidebar i').toggleClass('fa-times');
});

$('.post-preview').on('click', function (e) {
  const selector = '.continue-reading';
  let $ele = $(e.target);
  let url = null;

  if (!$ele.hasClass(selector)) {
    url = $ele.closest('.post-preview').find(selector)[0].href;
  }

  if (url) {
    window.location.href = url;
  }
});
